import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

const useStyles = createUseStyles(() => ({
  editButton: {
    color: "rgba(0, 0, 0) !important",
    "&:hover": {
      color: "rgba(0, 0, 0) !important",
      backgroundColor: "rgba(0, 0, 0, 0.04) !important",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.26) !important",
    },
    "& svg": {
      color: "inherit !important",
    },
  },
  textButton: {
    backgroundColor: "transparent !important",
    border: "none !important",
    color: "black !important",
    "&:hover": {
      backgroundColor: `${theme.color.gray1} !important`, // light gray hover
    },
    "&:focus": {
      backgroundColor: `${theme.color.gray1} !important`,
    },
  },
  bodyTable: {
    padding: 0,
  },
  containerInfo: {
    position: "relative",
  },
  infoHeader: {
    display: "flex",
    alignItems: "center",
    "& h3": {
      margin: "0 8px",
    },
  },
  warehouseInfo: {
    marginRight: theme.spacing(2),
    minWidth: "68%",
  },
  activitiesBlock: {
    width: "auto",
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: theme.color.gray5,
    },
  },
  createdAtBlock: {
    alignItems: "center",
    borderRight: `1px solid ${theme.color.gray2}`,
    borderLeft: `1px solid ${theme.color.gray2}`,
    color: theme.color.gray5,
    display: "flex",
    fontSize: 14,
    marginRight: theme.spacing(3),
    padding: "0 18px",
  },
  switchLabel: {
    "& span": {
      fontSize: 14,
    },
  },
  calendarIcon: {
    marginRight: theme.spacing(1),
    width: 18,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    marginLeft: theme.spacing(3),
    flex: 1,
  },
  topBlock: {
    "& .about": {
      display: "flex",
      "& .left, & .right": {
        flex: 1,
      },
      "& .left": {
        paddingRight: "10px",
        borderRight: `solid 1px ${theme.color.gray2}`,
      },
      "& .right": {
        marginLeft: "10px",
      },
      "& table": {
        width: "100%",
        borderSpacing: "0 20px",
      },
      "& .label": {
        color: theme.color.black,
        width: "50%",
        verticalAlign: "top",
      },
      "& .data": {
        color: theme.color.blue,
        fontWeight: "bold",
        width: "50%",
        verticalAlign: "top",
      },
      "& .isManageableBlock": {
        display: "flex",
        flexDirection: "row",
        "& .isManageableLabel": {
          width: "60px",
        },
      },
    },
  },
  activitiesDetails: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    color: theme.color.black,
    margin: [20, 0],
    "&:hover": {
      cursor: "pointer",
    },
  },
  bottomBlocks: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    margin: [theme.spacing(2), 0],
  },
  activitiesContainer: {
    display: "flex",
    flexWrap: "wrap",
  },
  activitiesGroup: {
    display: "flex",
    flexDirection: "column",
    flex: "0 1 50%",
    marginBottom: 20,
  },
  activities: {
    "& .MuiButtonBase-root": {
      padding: 7,
    },
    "& .MuiTypography-root": {
      fontWeight: "bold",
    },
  },
  subActivitiesBloc: {
    marginTop: 3,
    paddingLeft: 10,
    borderLeft: `1px solid ${theme.color.gray3}`,
  },
  subActivities: {
    composes: "$activities",
    "&.MuiFormControlLabel-root": {
      display: "block",
    },
    "&:first-child": {
      marginTop: -10,
    },
    "&:last-child": {
      marginBottom: -10,
    },
    "& .MuiTypography-root": {
      fontWeight: "normal",
    },
  },
  CompaniesContainer: {
    display: "flex",
    padding: " 0 20px",
    flexWrap: "wrap",
  },
  CompaniesItem: {
    paddingTop: "20px",
    borderBottom: "1px solid #DFE1E6",
    height: "42px",
    minWidth: "25%",
    transition: "all .2s ease-in-out",
    "&:hover": {
      cursor: "pointer",
      background: "#f1f1f1",
    },
  },
  CompaniesItemCell2: {
    marginRight: "20px",
  },
  CompaniesItemCell4: {
    marginRight: 0,
    minWidth: "calc(25% - 20px)",
  },
  popin: {
    padding: [20, 55],
    display: "flex",
    flexDirection: "column",
    maxWidth: "623px",
    minWidth: "623px !important",
  },
  Disabled: {
    color: "rgba(0,0,0,0.37) !important",
    pointerEvents: "none",
  },
  noPaddingTable: {
    padding: 0,
  },
}));

export default useStyles;
